import { useState } from "react";
import { collections } from "@/mocks/home";

export default function CollectionIndex() {
  const [active, setActive] = useState(0);
  const current = collections[active];

  return (
    <section id="collections" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <span className="text-[11px] tracking-[0.32em] text-secondary-500">合集索引</span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              按主题翻现场合集
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              每一本合集对应一个现场主题，录制片段与实拍记录都在里面按时间排好。点选左侧任意一条，右侧会同步预览该合集的封面。
            </p>

            <div className="mt-10 border-t border-background-200">
              {collections.map((item, index) => {
                const isActive = index === active;
                return (
                  <button
                    key={item.no}
                    type="button"
                    onClick={() => setActive(index)}
                    className={`group flex w-full cursor-pointer items-center gap-4 border-b border-background-200 px-3 py-5 text-left transition-colors duration-200 md:gap-6 md:px-4 ${
                      isActive
                        ? "border-l-2 border-l-primary-500 bg-background-100"
                        : "border-l-2 border-l-transparent hover:bg-background-100/70"
                    }`}
                  >
                    <span className="w-10 shrink-0 font-heading text-2xl font-bold text-secondary-300 md:text-3xl">
                      {item.no}
                    </span>
                    <span className="hidden h-14 w-20 shrink-0 overflow-hidden rounded-md sm:block">
                      <img
                        src={item.cover}
                        alt={`${item.title}现场封面`}
                        title={`私拍吃瓜 ${item.title}`}
                        className="h-full w-full object-cover object-top"
                      />
                    </span>
                    <span className="flex min-w-0 flex-1 flex-col gap-1.5">
                      <span className="flex flex-wrap items-center gap-2">
                        <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                          {item.title}
                        </span>
                        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
                          {item.tag}
                        </span>
                      </span>
                      <span className="truncate text-xs text-foreground-600 md:text-sm">
                        {item.desc}
                      </span>
                    </span>
                    <span className="hidden shrink-0 flex-col items-end gap-1 text-[11px] text-foreground-500 md:flex">
                      <span className="font-label">{item.count}</span>
                      <span>{item.updated}</span>
                    </span>
                    <i
                      className={`shrink-0 text-lg transition-colors ${
                        isActive ? "text-primary-600" : "text-background-400"
                      }`}
                    >
                      ri-arrow-right-s-line
                    </i>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <div className="relative overflow-hidden rounded-lg">
                <div className="h-[380px] w-full md:h-[520px]">
                  <img
                    src={current.cover}
                    alt={`${current.title}合集封面`}
                    title={`私拍吃瓜 ${current.title}`}
                    className="h-full w-full object-cover object-top transition-opacity duration-500"
                  />
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent p-5 md:p-6">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-[11px] text-background-50">
                    <i className="ri-live-line text-sm" />
                    {current.tag} · {current.count}
                  </span>
                  <h3 className="mt-3 font-heading text-lg font-semibold text-background-50 md:text-xl">
                    {current.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-background-300 md:text-sm">
                    {current.desc}
                  </p>
                </div>
              </div>
              <div className="mt-4 flex items-center justify-between text-[11px] text-foreground-500">
                <span>封面预览 · 第 {current.no} 本合集</span>
                <span className="font-label">{current.updated}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}